import { render } from "./AppSectionSidebarHeader.vue?vue&type=template&id=67d850b4&scoped=true&ts=true&lang=pug"
import script from "./AppSectionSidebarHeader.vue?vue&type=script&lang=ts"
export * from "./AppSectionSidebarHeader.vue?vue&type=script&lang=ts"

import "./AppSectionSidebarHeader.vue?vue&type=style&index=0&id=67d850b4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d850b4"]])

export default __exports__